import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Comandă {{method}} nouă!',
        scheduled: 'Comandă {{method}} programată!',
      },
      labels: {
        today: 'astăzi',
        time_remaining_to_accept: 'rămas pentru acceptare',
      },
      time_tag: {
        asap: '🕓 Ridicare în {{time}}',
        scheduled: '🕓 Ridicare {{day}} la {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Estimare aproximativă ridicare: {{time}}',
        scheduled: '🕓 Estimare aproximativă ridicare: {{day}} la {{time}}',
      },
      buttons: {
        confirm_order: 'Confirmă comanda',
        cancel_order: 'Anulează comanda',
      },
      feedback: {
        rough_estimate_warning:
          'Aceasta este doar o estimare aproximativă. Vei primi timpul real de pregătire odată ce un șofer este alocat și timpul de livrare este confirmat. La acel moment, bonul va fi tipărit automat.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Timp de pregătire',
      labels: {
        today: 'astăzi',
        order_time: {
          delivery: {
            asap: 'Livrare în',
            scheduled: 'Livrare pe',
          },
          other: {
            asap: 'Ridicare în',
            scheduled: 'Ridicare pe',
          },
        },
        can_you_make_it: 'Te poți încadra?',
        we_also_send_this_update_to_the_customer: 'Trimitem această actualizare și clientului',
      },
      buttons: {
        yes_lets_go: 'Da, mergem!',
        no_change_time: 'Nu, schimbă ora',
        confirm: 'Confirmă',
      },
      toasts: {
        order_confirmed: {
          title: 'Comanda #{{number}} confirmată',
          body: 'Nu pregăti încă! Te vom anunța când un șofer este alocat.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Din păcate, livrarea trebuie anulată deoarece șoferul nu este disponibil. Apasă pe cele trei puncte din dreapta sus pentru a anula comanda și a rambursa banii clientului.',
        [BackendErrorCode.DeliveryProviderException]:
          'Din păcate, livrarea trebuie anulată deoarece șoferul nu este disponibil. Apasă pe cele trei puncte din dreapta sus pentru a anula comanda și a rambursa banii clientului.',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Comandă acceptată, dar încă nu e rezervat niciun curier. Mai încercăm 15 minute și te anunțăm dacă nu găsim niciunul.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Ceva nu a funcționat, încearcă din nou',
  },
};
